<template>
  <div class="tips">
    <div class="tips-content">
      <div class="tips-logo"><img src="@/assets/img/PUNDIXCHAIN.svg" alt=""></div>
      <div class="tips-context">
        <div class="tips-context-title font-Md">Embracing Web3</div>
        <div class="tips-context-text">XWallet will be discontinued on December 31, 2023. Please withdraw your tokens at your earliest convenience. For details, please visit
          <a href="https://support.pundix.com/hc/en-us/articles/20170594847385-Embracing-Web3-XWallet-decommissioning-and-self-custodial-wallet-support" class="tips-strong font-Md" target="_blank" rel="noopener noreferrer">this announcement</a>.
        </div>
        <a class="tips-context-link font-Md" href="https://support.pundix.com/hc/en-us/articles/20170594847385-Embracing-Web3-XWallet-decommissioning-and-self-custodial-wallet-support"
           target="_blank" rel="noopener noreferrer">Read Now</a>
      </div>
      <a class="tips-btn font-Md white"
         href="https://support.pundix.com/hc/en-us/articles/20170594847385-Embracing-Web3-XWallet-decommissioning-and-self-custodial-wallet-support"
         target="_blank" rel="noopener noreferrer">Read Now</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "tips"
}
</script>

<style scoped lang="scss">
.tips{
  padding-top: 155px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
  background-color: rgb(18, 18, 18);
}
.tips-content{
  max-width: 1200px;
  width: 100%;
  min-height: 108px;
  background-color: #FFBE12;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 30px 24px 57px;
}
.tips-logo{
  width: 86px;
  flex-shrink: 0;
  img{
    display: block;
    width: 100%;
  }
}
.tips-context{
  padding-left: 57px;
  padding-right: 40px;
}
.tips-context-title{
  font-size: 24px;
  color: #080A32;
  line-height: 24px;
  font-weight: 500;
}
.tips-context-text{
  margin-top: 4px;
  font-size: 16px;
  color: rgba(8, 10, 50, 0.5);
  line-height: 20px;
  font-weight: 400;
}
.tips-context-link{
  margin-top: 10px;
  font-size: 14px;
  line-height: 20px;
  display: none;
  color: #080A32;
  transition: color 0.3s;
  &:hover{
    color: #0552DC;
  }
}
.tips-btn{
  background-color: #FFFFFF;
  border-radius: 28px;
  min-width: 200px;
  height: 56px;
  text-align: center;
  line-height: 56px;
  font-size: 16px;
  color: #080A32;
  font-weight: 500;
  position: relative;
  transition: transform 0.3s;
  z-index: 1;
  &:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    border-radius: 28px;
    background-image: linear-gradient(
            45deg,
            #1d97c7 0%,
            #5178f0 53%,
            #875ff3 100%
    );
    box-shadow: 0 8px 20px 0 rgba(8, 10, 50, 0);
    opacity: 0;
    transition-duration: 1s;
    transition-property: opacity, box-shadow;
  }
  &:not(.disable):not(.loading):not(.link):active {
    transform: scale(0.95);
  }
  &:not(.disable):not(.loading):not(.link):hover:before {
    box-shadow: 0 8px 20px 0 rgba(8, 10, 50, 0.06);
    opacity: 1;
  }
  &:not(.disable):not(.loading):not(.link):active:before {
    box-shadow: 0 6px 10px 0 rgba(8, 10, 50, 0.18);
  }
  &.white:not(.disable):not(.loading):hover {
    color: #fff;
  }
}
.tips-strong{
  color: #080A32;
  text-decoration: underline;
}

@media screen and (max-width: 980px) {
  .tips-content{
    padding: 14px 8px;
  }
  .tips-logo{
    width: 80px;
  }
  .tips-context{
    padding-left: 6px;
    padding-right: 6px;
  }
  .tips-context-link{
    display: inline-block;
  }
  .tips-btn{
    display: none;
  }
}

</style>